export class cSystemMessage {
  parent    = document.querySelector('body') as HTMLElement;
  container = document.createElement('div');

  constructor() {
    const messages: Array<{id: string, type: 'warning' | 'info', color: string, text: string}> = (window as any).cSystemMessages || [];

    if (messages.length === 0) return;

    this.container.style.bottom              = '0';
    this.container.style.right               = '0';
    this.container.style.left                = '0';
    this.container.style.position            = 'fixed';
    this.container.style.zIndex              = '5000';
    this.container.style.display             = 'flex';
    this.container.style.flexDirection       = 'column';

    let hasMessages = false;

    messages.forEach(msg => {
      const cookie = this.getCookie(`c_${msg.id}`);
      if (cookie === 'false') return;

      hasMessages = true;

      const div       = document.createElement('div');
      const div_inner = document.createElement('div');
      const button    = document.createElement('button');

      div.style.padding             = '16px';
      div.style.display             = 'grid';
      div.style.gridTemplateColumns = '1fr auto';
      div.style.alignItems          = 'center';
      div.style.justifyItems        = 'center';
      div.style.backgroundColor     = msg.color;

      div_inner.style.color       = 'white';
      div_inner.style.fontWeight  = '400';
      div_inner.style.fontSize    = '16px';
      div_inner.style.margin      = '0';
      div_inner.style.fontFamily  = 'var(--c-font-familiy-text)';
      div_inner.style.lineHeight  = '24px';

      button.innerText             = 'X';
      button.type                  = 'button';
      button.style.color           = 'white';
      
      if (msg.type === 'warning') {
        button.style.backgroundColor = '#d30000';
        button.classList.add('c-system-message-button-alert');
      } else {
        button.style.backgroundColor = 'rgba(0,0,0,0.2)';
        button.style.border          = 'none';
        button.style.padding         = '4px 12px';
        button.style.borderRadius    = '2px';
        button.classList.add('c-system-message-button-info');
      }
      
      div.classList.add('c-system-message');
      div_inner.innerHTML = msg.text;

      div.append(div_inner);
      div.append(button);
      this.container.append(div);

      button.addEventListener('click', () => {
        div.style.display = 'none';
        this.setCookie(`c_${msg.id}`, 'false', 1);
      });
    });

    if (hasMessages) {
      this.parent.append(this.container);
    }
  }

  setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days*24*60*60*1000);
    const expires = date.toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`
  }

  getCookie(name: string) {
    const value = 
      decodeURIComponent(document.cookie)
      .split('; ')
      .filter(val => val.indexOf(`${name}=`) === 0)
      .map(val => val.substring(`${name}=`.length))
      [0] ?? '';
      
    return value;
  }

}